export default __webpack_public_path__ + "static/media/horns-and-stars-2x.462ede0c.png";